import { render, staticRenderFns } from "./CommunityAccessError.vue?vue&type=template&id=53feccae&scoped=true"
import script from "./CommunityAccessError.vue?vue&type=script&lang=ts"
export * from "./CommunityAccessError.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53feccae",
  null
  
)

export default component.exports